import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {AnalysisFull} from '../types/analysis.types'

export const QueryKey = 'analysis-detail'

export const useGetAnalysisDetail = (
  analysisId: string,
  options?: Omit<UseQueryOptions<AnalysisFull, AxiosError>, 'queryKey' | 'queryFn'>,
  keyPrefix?: string
) => {
  return useQuery<AnalysisFull, AxiosError>({
    queryKey: [QueryKey, analysisId, keyPrefix],
    queryFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}`
      return (await ApiClient.axiosInstance.get<AnalysisFull>(path)).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
